var _excluded = ["bordered", "outerBordered", "innerBordered", "rowBordered", "colBordered", "stripe", "striped", "size", "maxHeight", "noHeader", "showHeader", "loading", "loadingZIndex", "paginationProps", "className", "summaryTop"],
    _excluded2 = ["position", "align"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useMemo, useRef } from 'react';
import { isObject, scrollTo, isFunction } from '@okee-uikit/react-utils';
import { useRefCallback } from '@okee-uikit/react-hooks';
import { Pager } from '../../pager';
import { BlockLoading } from '../../loading/BaseLoading';
import { useTableImplement, useTableCep } from '../implements/implement';
import { CaptionsHeightContext, useContainerSizeAndScroll, useTableCaptionsHeightInit, useTableColumnsWidthInit, ColumnsWidthContext } from '../implements/size';
import { SectionsContext, useTableSectionsInit } from '../implements/sections';
import { useTable } from '../context';
import { TableBody } from './body';
import { TableHead } from './head';
import { TableColGroup } from './colgroup';
import { TableShadow } from './shadow';
import { TableEmpty } from './empty';
export function TableRoot(props) {
  var _a, _b, _c, _d;

  var propBordered = props.bordered,
      propOuterBordered = props.outerBordered,
      propInnerBordered = props.innerBordered,
      propRowBordered = props.rowBordered,
      propColBordered = props.colBordered,
      stripe = props.stripe,
      _props$striped = props.striped,
      striped = _props$striped === void 0 ? stripe : _props$striped,
      _props$size = props.size,
      size = _props$size === void 0 ? 'md' : _props$size,
      maxHeight = props.maxHeight,
      _props$noHeader = props.noHeader,
      noHeader = _props$noHeader === void 0 ? false : _props$noHeader,
      _props$showHeader = props.showHeader,
      showHeader = _props$showHeader === void 0 ? !noHeader : _props$showHeader,
      loading = props.loading,
      loadingZIndex = props.loadingZIndex,
      paginationProps = props.paginationProps,
      propClassName = props.className,
      propSummaryTop = props.summaryTop,
      extra = _objectWithoutProperties(props, _excluded);

  var outerBordered = propOuterBordered !== null && propOuterBordered !== void 0 ? propOuterBordered : propBordered;
  var rowBordered = (_b = (_a = propRowBordered !== null && propRowBordered !== void 0 ? propRowBordered : propInnerBordered) !== null && _a !== void 0 ? _a : propBordered) !== null && _b !== void 0 ? _b : true;
  var colBordered = (_d = (_c = propColBordered !== null && propColBordered !== void 0 ? propColBordered : propInnerBordered) !== null && _c !== void 0 ? _c : propBordered) !== null && _d !== void 0 ? _d : false;

  var _useTableCep = useTableCep(),
      comp = _useTableCep.comp,
      elem = _useTableCep.elem;

  var _useTableImplement = useTableImplement(),
      Table = _useTableImplement.Table;

  var context = useTable();
  var rowCount = context.rowCount,
      deep = context.deep,
      colCount = context.colCount,
      paginationState = context.paginationState,
      paginationActions = context.paginationActions;

  var _useTableSectionsInit = useTableSectionsInit(extra, rowBordered),
      _useTableSectionsInit2 = _slicedToArray(_useTableSectionsInit, 4),
      sectionsContext = _useTableSectionsInit2[0],
      attrs = _useTableSectionsInit2[1],
      headInfo = _useTableSectionsInit2[2],
      bodyInfo = _useTableSectionsInit2[3];

  var headContainerRef = useRef(null);

  var _useTableCaptionsHeig = useTableCaptionsHeightInit(context),
      _useTableCaptionsHeig2 = _slicedToArray(_useTableCaptionsHeig, 2),
      _useTableCaptionsHeig3 = _useTableCaptionsHeig2[0],
      captionRef = _useTableCaptionsHeig3.captionRef,
      theadRef = _useTableCaptionsHeig3.theadRef,
      tbodyRef = _useTableCaptionsHeig3.tbodyRef,
      heightContext = _useTableCaptionsHeig2[1];

  var captionHeight = heightContext.captionHeight,
      theadHeights = heightContext.theadHeights;
  var theadHeight = theadHeights.reduce(function (total, cur) {
    return total + cur;
  }, captionHeight);

  var _useContainerSizeAndS = useContainerSizeAndScroll([Table, context]),
      _useContainerSizeAndS2 = _slicedToArray(_useContainerSizeAndS, 4),
      containerRef = _useContainerSizeAndS2[0],
      _useContainerSizeAndS3 = _useContainerSizeAndS2[1],
      containerClientWidth = _useContainerSizeAndS3.clientWidth,
      containerClientHeight = _useContainerSizeAndS3.clientHeight,
      scrollBarWidth = _useContainerSizeAndS3.scrollBarWidth,
      scrollStart = _useContainerSizeAndS2[2],
      scrollEnd = _useContainerSizeAndS2[3];

  var columnsWidthContext = useTableColumnsWidthInit(containerClientWidth);
  var tableMinWidth = columnsWidthContext.tableMinWidth,
      scrollable = columnsWidthContext.scrollable,
      containerInnerWidth = columnsWidthContext.containerInnerWidth;
  var paginationTop;
  var paginationBottom;

  if (paginationState && paginationActions) {
    var _ref = paginationProps || {},
        _ref$position = _ref.position,
        position = _ref$position === void 0 ? 'bottom' : _ref$position,
        _ref$align = _ref.align,
        align = _ref$align === void 0 ? 'end' : _ref$align,
        paginationAttrs = _objectWithoutProperties(_ref, _excluded2);

    var pager = function pager() {
      return React.createElement(Pager, _objectSpread(_objectSpread({}, paginationAttrs), {}, {
        page: paginationState.page,
        pageSize: paginationState.size,
        total: paginationState.total,
        onPageChange: paginationActions.setPage,
        onPageSizeChange: function onPageSizeChange(p, s) {
          paginationActions.setSize(s);
        },
        disabled: loading
      }));
    };

    if (position === 'both' || position === 'top') {
      paginationTop = React.createElement("div", {
        key: "pagination-top",
        className: elem('Pagination', {
          top: true,
          align: align
        })
      }, pager());
    }

    if (position === 'both' || position === 'bottom') {
      paginationBottom = React.createElement("div", {
        key: "pagination-bottom",
        className: elem('Pagination', {
          bottom: true,
          align: align
        })
      }, pager());
    }
  }

  var loadingNode;

  if (loading) {
    loadingNode = React.createElement("div", {
      key: "loading",
      className: elem('Loading'),
      style: {
        paddingTop: "".concat(theadHeight, "px")
      }
    }, React.createElement(BlockLoading, {
      show: true,
      zIndex: loadingZIndex
    }));
  }

  var scroll = useRefCallback(function (e) {
    if (theadFixed && e.target.className.includes(elem('Container'))) {
      var scrollLeft = e.target.scrollLeft;
      scrollTo(headContainerRef.current, {
        left: scrollLeft
      });
      scrollTo(containerRef.current, {
        left: scrollLeft
      });
    }
  });

  var theadProps = _objectSpread(_objectSpread({}, headInfo.props), headInfo.callback(context));

  var theadFixed = !!theadProps.positionSticky;
  var theadSticky = theadProps.sticky;
  var className = comp({
    outerBordered: outerBordered,
    rowBordered: rowBordered,
    colBordered: colBordered,
    striped: striped,
    size: size,
    loading: loading,
    scrollStart: scrollStart,
    scrollEnd: scrollEnd,
    theadFixed: theadFixed
  }, propClassName);
  var summaryTop = useMemo(function () {
    return isFunction(propSummaryTop) ? propSummaryTop(context) : propSummaryTop;
  }, [propSummaryTop, context]);
  return React.createElement(SectionsContext.Provider, {
    value: sectionsContext
  }, React.createElement(CaptionsHeightContext.Provider, {
    value: heightContext
  }, React.createElement(ColumnsWidthContext.Provider, {
    value: columnsWidthContext
  }, React.createElement("div", _objectSpread({
    className: className
  }, attrs), paginationTop, React.createElement("div", {
    key: "frame",
    className: elem('Frame', {
      theadFixed: theadFixed
    })
  }, theadFixed && React.createElement("div", {
    ref: headContainerRef,
    key: "thead",
    className: elem('Container', {
      head: true
    }),
    style: isObject(theadProps.positionSticky) && _objectSpread({}, theadProps.positionSticky) || undefined,
    onScroll: scroll
  }, React.createElement(TableShadow, {
    key: "column-shadow",
    width: tableMinWidth + scrollBarWidth,
    theadHeight: theadHeight,
    scrollBarWidth: scrollBarWidth
  }), React.createElement(Table, {
    key: "implement-head",
    className: elem('Implement', {
      theadFixed: theadFixed
    }),
    role: "table",
    "aria-rowcount": rowCount + deep,
    "aria-colcount": colCount,
    style: {
      minWidth: "".concat(tableMinWidth, "px")
    }
  }, React.createElement(TableColGroup, {
    key: "colgroup",
    srollBarWidth: scrollBarWidth
  }), showHeader && React.createElement(React.Fragment, null, React.createElement(TableHead, _objectSpread(_objectSpread({}, theadProps), {}, {
    key: "head",
    ref: theadRef,
    scrollBarWidth: scrollBarWidth
  }), summaryTop)))), React.createElement("div", {
    key: "container",
    ref: containerRef,
    className: elem('Container', {
      body: theadFixed,
      scrollable: scrollable
    }),
    style: {
      maxHeight: maxHeight
    },
    onScroll: scroll
  }, React.createElement(TableShadow, _objectSpread({
    key: "column-shadow",
    width: tableMinWidth,
    height: containerClientHeight - 1
  }, !theadFixed && {
    theadHeight: theadHeight,
    theadSticky: theadSticky
  } || {})), React.createElement(Table, {
    key: "implement",
    className: elem('Implement'),
    role: "table",
    "aria-rowcount": rowCount + deep,
    "aria-colcount": colCount,
    style: {
      minWidth: "".concat(tableMinWidth, "px")
    }
  }, React.createElement(TableColGroup, {
    key: "colgroup"
  }), showHeader && !theadFixed && React.createElement(TableHead, _objectSpread(_objectSpread({}, theadProps), {}, {
    key: "head",
    ref: theadRef
  }), summaryTop), React.createElement(TableBody, _objectSpread(_objectSpread(_objectSpread({}, bodyInfo.props), bodyInfo.callback(context)), {}, {
    key: "body"
  }))), !!containerInnerWidth && React.createElement(TableEmpty, null)), loadingNode), paginationBottom))));
}